import { Modal as ModalCore, ModalProps } from '@phonepe/enigma-ui';

const Modal = ({ children, ...props }: ModalProps) => {
	return <ModalCore {...props}>{children}</ModalCore>;
};

export default Modal;
